<template>
  <div class="page page2 multi">
    <van-form @submit="submitForm">
      <div class="form">
        <div class="tg-multi-jx">
          <!-- <van-uploader> -->
            <div class="drag-tips" style="color: #999;" v-if="form.imgs.length>0">*长按可拖拽排序</div>
            <div class="tg-multi-jx-list">
              <draggable v-model="form.imgs" animation="500" chosen-class="chosenDragItem" @update="dragUpdate">
                <div class="item-wrap" v-for="(item, index) in form.imgs" :key="index">
                  <div class="item">
                    <div class="img-wrap">
                      <a
                        href="javascript: void(0);"
                        class="upload-pic-multi"
                        @click="showSwiper(index)"
                        ><img :src="item.url"
                      /></a>
                      <van-loading
                        size="24px"
                        vertical
                        v-show="
                          fileList[index] &&
                            fileList[index].status &&
                            fileList[index].status == 'uploading'
                        "
                        >上传中...</van-loading
                      >
                    </div>
                    <div class="desc">
                      <van-field
                        v-model="item.describe"
                        type="textarea"
                        maxlength="1000"
                        placeholder="请输入作品说明"
                      />
                    </div>
                    <div class="btn-group">
                      <van-icon name="arrow-up" @click.stop="moveUpDragItem(index)" />
                      <van-icon name="cross" @click.stop="deleteUpload(index)" />
                      <van-icon name="arrow-down" @click.stop="moveDownDragItem(index)" />
                    </div>
                  </div>
                  <div class="tips" style="color: red;" v-if="item.tips">{{ item.tips }}</div>
                </div>
              </draggable>
            </div>
            <div class="add-item" @click="chooseFromSys">
              <div class="van-uploader__upload">
                <i
                  class="van-icon van-icon-photograph van-uploader__upload-icon"
                ></i>
                <p style="color: #999;margin-top: 10px;">点击上传图片</p>
              </div>
            </div>
          <van-uploader
            style="display:none;"
            v-model="fileList"
            ref="uploadFile"
            :after-read="handleUpload"
            :before-read="beforeUpload"
            @delete="deleteUpload"
            :preview-image="false"
            multiple
            @click-preview="showSwiper"
            :max-count="maxCount"
            :preview-full-image="false"
          >
          </van-uploader>
        </div>
        <div class="tips" v-if="msg != ''">
          {{ msg }}
        </div>
        <div class="tips">
          *本赛事仅支持{{ gourp_limit.typestr }}格式且不大于{{
            gourp_limit.size
          }}M的图片
        </div>
        <div class="info-ipt">
          <van-field
            class="required"
            v-model="form.mname"
            name="作品标题"
            label="作品标题"
            maxlength="15"
            placeholder="请输入15字以内作品名称"
            :rules="[{ required: true, message: '作品标题不能为空' }]"
          />
          <van-field
            class="required"
            v-model="form.custom_fields.shoot_date"
            name="拍摄日期区间"
            label="拍摄日期区间"
            placeholder="请输入拍摄日期区间 例：2019-2023"
            :rules="[{ required: true, message: '拍摄日期区间不能为空' }]"
          />
          <van-field
            class="required"
            v-model="form.shoot_address"
            name="拍摄地址"
            label="拍摄地址"
            placeholder="请输入作品拍摄地"
            :rules="[{ required: true, message: '拍摄地址不能为空' }]"
          />
          <van-field
            class="required"
            v-model="form.remark"
            rows="5"
            autosize
            label="作品总说明"
            type="textarea"
            maxlength="1000"
            placeholder="请输入作品总说明"
            :rules="[{ required: true, message: '作品总说明不能为空' }]"
            show-word-limit
          />
        </div>
        <div class="submit-item">
          <label @click="isPromise = !isPromise">
            <input class="check" type="checkbox" :checked="isPromise" />
            <span class="text"> 本人承诺递交的记录类作品未对原始影像进行违规处理</span>
          </label>
        </div>
        <div class="submit-item">
          <label @click="changeSync">
            <input class="check" type="checkbox" :checked="form.is_app_show" />
            <span class="text" @click.stop> 我同意将该图片同步到app发现中</span>
          </label>
        </div>
        <div class="agreement-tips">
          发布即表示您已同意我们的<a
            href="https://www.pai2345.com/wap/treaty/index/id/9"
            >原创条款</a
          >
        </div>
        <van-button
          class="btn-submit"
          round
          block
          type="warning"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
    <div class="swiper-wrap" v-show="isShowSwiper">
      <div class="swiper-container detail">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in form.imgs"
            :key="index"
          >
            <img :src="item.url" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <a
          class="del-btn"
          href="javascript:void(0)"
          @click="deleteUploadSwiper()"
        ></a>
        <a
          class="close-btn"
          href="javascript:void(0)"
          @click="isShowSwiper = false"
        ></a>
      </div>
    </div>
    <ChooseFile
      :chooseForm1="chooseForm1"
      :max="maxCount"
      :chooseType="chooseType"
      :uploadImages="form.imgs"
      @changeChooseForm1="changeChooseForm1"
      @changeChooseForm2="changeChooseForm2"
      @chooseFromSys="chooseFromSys"
      @chooseComplete="chooseComplete"
    />
  </div>
</template>

<script>
import Swiper from "swiper/js/swiper.js";
import ChooseFile from "@/components/ChooseFile";
import draggable from 'vuedraggable';
import EXIF from "exif-js";
export default {
  components: {
    ChooseFile,
    draggable,
  },
  data() {
    return {
      isShowSwiper: false,
      uploadBg: require("@/static/res/images/img-bg.png"),
      dialogImageUrl: "",
      dialogVisible: false,
      id: this.$route.params.id,
      define: [],
      custom_fields: [],
      group: this.$route.query.group,
      // form
      form: {
        work_id: this.$route.query.work_id,
        match_id: this.$route.params.id,
        mname: "",
        remark: "",
        date:'',
        imgs: [],
        group: this.$route.query.group,
        shoot_address: "",
        custom_fields: [],
        // 是否同意条款
        is_app_show: 0,
        is_finding: 0,
        works_type: 2,
        shoot_date:'',
      },
      // 限制图片数量
      uploadImgLen: 0,
      maxCount: 1,
      accept: "image/*",
      fileList: [
        { file: "" },
        // {
        //   percent: 0,
        //   url: "",
        //   // status: 'uploading',
        //   // message: '上传中...'
        // }
      ],
      isUploaded: true,
      gourp_limit: {
        typestr: "",
        imgtype: [],
        size: "",
        end: 2,
        start: 1,
        is_open_psd: 0,
      },
      msg: "",
      has_submit: true,
      loading: false,
      swiper: "",
      realIndex: 0,
      chooseForm1: false,
      chooseForm2: false,
      // 已选择的图片
      uploadImages: [],
      chooseType: "multi",
      showCalendar:false,
      ifDateRange:false,
      isPromise: true,
      isSubmit: false,
    };
  },
  computed: {
    // newFileList() {},
  },
  methods: {
    // changePhotos() {
    //   this.$refs.multi.chooseFile();
    // },
    changePhotos() {
      this.chooseForm1 = true;
    },
    changeChooseForm1(val) {
      this.chooseForm1 = val;
    },
    changeChooseForm2(val) {
      this.chooseForm2 = val;
    },
    chooseFromSys() {
      this.$refs.uploadFile.chooseFile();
    },
    chooseComplete(val) {
      this.form.imgs = val;
      this.fileList = val;
    },
    checkValFilter(item) {
      // 未打开图库删减图库内容时，校正checkVal值
      // session取值
      let checkVal = JSON.parse(sessionStorage.getItem("checkVal")) || [];
      // 过滤
      checkVal = checkVal.filter((val) => {
        return val != item.id;
      });
      // 存储
      if (checkVal.length <= 0) {
        sessionStorage.removeItem("checkVal");
      } else {
        sessionStorage.setItem("checkVal", JSON.stringify(checkVal));
      }
    },
    initSwiper() {
      var that = this;
      // var mySwiper =
      this.swiper = new Swiper(".swiper-container", {
        initialSlide: that.realIndex,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        // loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          // slideChangeTransitionEnd
          slideChangeTransitionEnd: function() {
            that.realIndex = this.realIndex;
          },
        },
      });
    },
    showSwiper(index) {
      this.isShowSwiper = true;
      this.realIndex = index;
      this.initSwiper();
    },
    initFileList(end) {
      this.fileList = [];
      for (var j = 0; j < end; j++) {
        this.fileList.push({
          percent: 0,
          url: "",
        });
      }
    },
    addFileList(arr) {
      for (var i = 0; i < arr.length; i++) {
        this.fileList[i].file.key = arr[i].image;
        this.fileList[i].file.url = arr[i].url.split("/uploads")[0];
      }
    },
    changeSync() {
      this.form.is_app_show = !this.form.is_app_show;
    },
    // 文件校验
    fileValid(file) {
      //类型判断need imgtype: [],
      let isJPG = this.tools.hasImgType(this.gourp_limit.imgtype, file.type);
      let isLt2M = file.size / 1024 / 1024 < this.gourp_limit.size;
      if (!isJPG) {
        this.$toast.fail(
          "上传图片只能是 " + this.gourp_limit.typestr + " 格式!"
        );
        return false;
      }
      if (file.size / 1024 / 1024 < 2) {
        this.$toast.fail(
          "上传文件大小不能小于3MB!"
        );
        return false;
      }
      if (!isLt2M) {
        this.$toast.fail(
          "上传图片大小不能超过 " + this.gourp_limit.size + "MB!"
        );
        return false;
      }
      return isJPG && isLt2M;
    },
    // 图片上传前处理
    beforeUpload(file) {
      if (typeof file == "object" && file.length > 0) {
        let result = file.filter((item) => {
          return this.fileValid(item);
        });
        // 数组过滤后长度不等于原先的，说明有文件不符合预期，不上传
        return result.length == file.length;
      } else {
        return this.fileValid(file);
      }
    },
    // 图片上传事件抽象
    upload(file) {
      // console.log('file:', file);
      // 传图前，loading状态
      file.status = "uploading";
      file.message = "上传中...";
      let length = this.form.imgs.length;
      this.form.imgs[length] = { isLoading: true, url: file.content, describe: '', hasExif: false};
      let that = this;
      EXIF.getData(file.file, function(){
        var exifData = EXIF.getAllTags(this);
        // console.log('exif===========', exifData);
        // 判断exif信息
        if(typeof exifData.DateTimeOriginal !== 'undefined'){
          let dateTime = exifData.DateTimeOriginal.replace(/:/g, "-");
          dateTime = dateTime.split(" ");
          that.form.imgs[length].hasExif = true;
        }
      });
      // 图片上传到OSS
      this.tools
        .uploadaly(file.file)
        .then((res) => {
          if (res) {
            this.form.imgs[length].isLoading = false;
            this.form.imgs[length].url = res;
            file.status = "";
            file.message = "";
          }
        })
        .catch((err) => {
          console.log(err);
          // 传图失败，减少imgs长度
          this.form.imgs.pop();
          file.status = "fail";
          file.message = "上传失败";
        });
    },
    // 图片上传实际函数
    handleUpload(files) {
      if (typeof files == "object" && files.length > 0) {
        for (let file of files) {
          this.upload(file);
        }
      } else {
        this.upload(files);
      }
    },
    deleteUpload(index) {
      this.checkValFilter(this.form.imgs[index]);
      this.form.imgs.splice(index, 1);
    },
    deleteUploadSwiper() {
      this.$dialog
        .confirm({
          title: "",
          message: "要删除这张照片吗？",
          confirmButtonText: "删除",
          cancelButtonText: "取消",
        })
        .then(() => {
          // on confirm
          this.checkValFilter(this.form.imgs[this.realIndex]);
          this.fileList.splice(this.realIndex, 1);
          this.form.imgs.splice(this.realIndex, 1);
          if (this.fileList.length == 0) {
            this.isShowSwiper = false;
          }
        })
        .catch(() => {
          // on cancel
          return false;
        });

    },
    submitForm() {
      // let that = this;
      if (!this.$store.state.isLogin) {
        /* eslint-disable */
        // 调用passport
        passportLogin.login();
        /* eslint-enable */
        return false;
      }
      if (this.isSubmit == false) {
        if (this.form.image == "") {
          this.$toast.fail("请先上传图片");
          return false;
        }
        if (this.gourp_limit.start == 0) {
          this.gourp_limit.start = 2;
        }
        if (this.form.imgs.length < this.gourp_limit.start) {
          this.$toast.fail({
            message:
              "本次投稿需要上传至少 " +
              this.gourp_limit.start +
              " 张图片\n请调整后重试！",
            duration: 3500,
            className: "long-toast",
          });
          return false
        }
        if (this.loading) {
          this.$toast.fail("图片上传中，请稍候...");
          return false;
        }
        // 图片校验
        let uploadError = false;
        for(let i in this.form.imgs){
          console.log('describe', this.form.imgs[i].describe);
          // if(this.form.imgs[i].hasExif == false){
          //   // 判断EXIF信息
          //   uploadError = true;
          //   this.form.imgs[i].tips = '图片缺少EXIF完整信息!';
          // }else 
          if(this.form.imgs[i].describe == ''){
            // 判断图片说明是否为空
            uploadError = true;
            this.form.imgs[i].tips = '图片说明不能为空!';
          }else{
            this.form.imgs[i].tips = '';
          }
        }
        if(uploadError){
          this.$forceUpdate();
          this.$toast.fail("图片校验失败请重新检查！");
          return false;
        }
        if (!this.isPromise) {
          this.$toast.fail("请确定承诺");
          return false;
        }
        let custom_fields = {
          shoot_date: this.form.custom_fields.shoot_date,
        };
        this.isSubmit = true;
        this.axios
        .post("/match/join_multi", {
          work_id: this.form.work_id,
          match_id: this.form.match_id,
          mname: this.form.mname,
          remark: this.form.remark,
          imgs: this.form.imgs,
          group: this.form.group,
          shoot_address: this.form.shoot_address,
          custom_fields: custom_fields,
          is_finding: this.form.is_app_show,
          works_type: 2,
          source: 1,
        })
        .then(
          (res) => {
            if (res.data.code == 200) {
              if (this.form.work_id > 0) {
                sessionStorage.removeItem("checkVal");
                // 作品的再投一稿
                this.$router.push({
                  query: {
                    group: this.group,
                  },
                });
              }
              this.$dialog
                .confirm({
                  title: "",
                  message: "投稿成功!",
                  confirmButtonText: "再投一稿",
                  cancelButtonText: "返回赛事页",
                })
                .then(() => {
                  // on confirm
                  window.location.reload();
                  sessionStorage.removeItem("checkVal");
                })
                .catch((action) => {
                  // on cancel
                  console.log(action);
                  sessionStorage.removeItem("checkVal");
                  this.$router.push({
                    name: "intro",
                  });
                });
            } else {
              // this.$toast.fail(res.data.msg);
              this.$toast.fail({
                message: res.data.msg,
                duration: 3500,
                className: "long-toast",
              });
            }
            this.isSubmit = false;
          },
          (err) => {
            this.isSubmit = false;
            console.log(err);
          }
        );
      }
    },
    //列表更新
    dragUpdate(){
      
    },
    //上移
    moveUpDragItem(index){
      if(index===0){
        return false
      }
      this.form.imgs.splice(index - 1, 1, ...this.form.imgs.splice(index, 1, this.form.imgs[index - 1]));
    },
    //下移
    moveDownDragItem(index){
      if(index===this.form.imgs.length-1){
        return false
      }
      this.form.imgs.splice(index, 1, ...this.form.imgs.splice(index + 1, 1, this.form.imgs[index]));
    },
    //选择日期
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirmCalendar(date){
      console.log(date);
      if(this.ifDateRange){
        const [start, end] = date;
        this.form.shoot_date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      }else{
        this.form.shoot_date = `${this.formatDate(date)}`;
      };
      this.showCalendar = false;
    },
    //选择器
    onConfirmPicker(value) {
      this.form.picker = value;
      this.showPicker = false;
    },
  },
  created() {
    
  },
  mounted() {
    // 每次加载都清空图库选择状态
    sessionStorage.removeItem("checkVal");
    // 获取比赛详情
    this.tools
      .getMatchDetail({ id: this.id, group: this.group })
      .then((res) => {
        this.custom_fields = res.custom_fields;
        this.msg = res.match_limit.match_introduce;
        this.form.is_app_show = res.match_limit.is_app_show;
        var params = res.gourp_limit;
        if (params) {
          this.gourp_limit = Object.assign(this.gourp_limit, params);
          this.gourp_limit.size = params.file_limit;
          this.gourp_limit.imgtype = params.file_limit_type;
          this.maxCount = this.gourp_limit.end == 0 ? 15 : this.gourp_limit.end;
          // this.initFileList(this.gourp_limit.end);
          this.gourp_limit.typestr = this.gourp_limit.imgtype.toString();
          if (this.$route.query.work_id) {
            this.tools
              .getWorksDetail({ work_id: this.$route.query.work_id })
              .then((res) => {
                // this.form = res.form;
                Object.assign(this.form, res.form);
                // this.addFileList(res.imgs);
                this.form.imgs = res.imgs;
                this.fileList = res.imgs;
              });
          }
        }
      });
  },
};
</script>

<style lang="scss">
@import "../../../node_modules/swiper/css/swiper.min.css";
.multi {
  .tg-multi {
    padding: 30px 0 0 30px;
    margin-top: 30px;
    li {
      margin: 0 30px 30px 0;
      .van-loading {
        background: rgba(0, 0, 0, 0.5);
        height: 100%;
        border-radius: 8px; /* no */
        align-items: center;
        justify-content: center;
        color: #fff;
        .van-loading__text {
          color: #fff;
        }
      }
      img {
        border-radius: 8px; /* no */
      }
    }
  }
  textarea {
    word-break: break-all;
    word-wrap: break-word;
  }
  .van-uploader__upload,
  .van-uploader__preview {
    margin: 0 30px 30px 0;
    width: 210px;
    height: 210px;
  }

  .van-uploader__preview-image {
    width: 210px;
    height: 210px;
  }
  .van-field__label {
    width: 180px;
  }
  .required {
    .van-field__label {
      span::after {
        content: "*";
        color: #dd855c;
        position: absolute;
        left: 18px;
        top: 30px;
      }
    }
  }
  .van-uploader__input-wrapper {
    width: 100vw;
  }
  .van-button {
    line-height: 1;
  }
  .van-uploader__preview-delete {
    font-size: 24px; /* no */
  }
  .swiper-wrap {
    position: fixed;
    top: 0;
    height: 100vh;
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #ef7f48;
}
.long-toast {
  width: 80%;
  max-width: 80%;
}


.tg-multi-jx{
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  margin-top: 30px;
  .tg-multi-jx-list{
    margin-bottom: 20px;
    .item-wrap{
      width: 100%;
      padding: 20px 0;
      box-sizing: border-box;
      border-bottom: 1px dotted #ededed;
      .tips{
        padding:0;
        margin-top: 20px;
      }
    }
    .item{
      width: 100%;
      display: flex;
      position: relative;
      .img-wrap{
        width:160px;
        height:160px;
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        .upload-pic-multi{
          width:100%;
          height:100%;
          img{
            width:100%;
            height:100%;
            object-fit: cover;
          }
        }
        .van-loading {
          position: absolute;
          left: 0;
          top: 0;
          background: rgba(0, 0, 0, 0.5);
          width: 100%;
          height: 100%;
          border-radius: 8px; /* no */
          align-items: center;
          justify-content: center;
          color: #fff;
          .van-loading__text {
            color: #fff;
          }
        }
      }
      .desc{
        flex: 1;
        height: 160px;
        margin-left: 20px;
        padding-right: 50px;
        background: #f5f5f5;
        border-radius: 10px;
        .van-cell{
          background:none;
          padding: 20px;
        }
      }
      .btn-group{
        width: 44px;
        border-radius: 10px;
        height: 100%;
        position: absolute;
        right: 0px;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: #eee;
        i{
          width: 100%;
          height: 33%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #777;
        }
      }
      &:last-child{
        border: none;
      }
    }
    .chosenDragItem{
     
    }
  }
  .add-item{
    .van-uploader__upload{
      width: 100%;
      border:1px dotted #ddd;
      box-sizing: border-box;
    }
  }
}
</style>
